// import 'animate.css';
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

import './scss/block_3.scss';
// import '../main/js/tweenmax.js';
// import dndPromotion from '../main/js/promotion2.js';

window.addEventListener("load", function(){
    var swiper = new Swiper(".mySwiper3", {
        slidesPerView: 3,
        watchSlidesProgress: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});

